<closeable-dialog class="defibrillator-dialog-container" [displayFooter]="showFooter">
  <div class="dialog-header title" dialog-card-header><label>{{ 'automaticExternalDefibrillator' | translate }}  &nbsp;</label>
    <div class="status-badge" [ngClass]="'defibrillator-badge-' + defibrillatorStatus"> {{ 'defibrillator-badge-' + defibrillatorStatusMessage | translate }}
      <label>
        <img src="{{this.chargedBatteryIcon}}" width="22px" height="22px" *ngIf="isBatteryErrorAED && !isLastTestTimeNotValid && !showTestError">
      </label>
    </div>
  </div>

  <div dialog-card-body class="dialog-body full-height">

    <ng-container >
      <div *ngIf="!loading" class="centered-image">
        <img class="img1" src="assets/images/full-automatic-display-aed.png" width="196" height="250" *ngIf="isFullAutomaticDisplay"/>
        <img class="img2" src="assets/images/full-automatic-non-display-aed.png" width="196" height="250" *ngIf="isFullAutomaticNonDisplay"/>
        <img class="img3" src="assets/images/half-automatic-display-aed.png" width="196" height="250" *ngIf="isHalfAutomaticDisplay"/>
        <img class="img4" src="assets/images/half-automatic-non-display-aed.png" width="196" height="250" *ngIf="isHalfAutomaticNonDisplay"/>
      </div>
      <div *ngIf="loading" class="centered-image" style="width: 196px; height: 250px; padding: 2vmin; ">
        <ng-lottie [options]="lottieOptions"></ng-lottie>
      </div>
    </ng-container>

    <nb-tabset (changeTab)="onTabChange($event)">
      <nb-tab tabTitle="{{'summary' | translate}}" [active]="activeTab === 'summary'" [tabId]="'summary'">
        <div class="d-flex ">
          <div class="flex-60">
            <label class="column-info header"><u>{{'General Information' | translate}} : </u></label>
          </div>
          <div class="flex-60">
            <label class="column-info header"><u>{{'IOT Module Information' | translate}} : </u></label>
          </div>
        </div>


        <div class="d-flex ">
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title">{{'AEDDeviceModel' | translate}} : </label>
            <label class="column-info content">{{AEDDeviceModel === 0 ?
              ('AEDDeviceModelHalf' | translate) : 'AEDDeviceModelFull' | translate }}</label>
          </div>
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title"> {{'iotModuleSerialNumber' | translate}} :</label>
            <label class="column-info content">{{iotModuleSerialNumber}}</label>
          </div>
        </div>

        <div class="d-flex ">
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title">{{'AEDSerialNumber' | translate}} : </label>
            <label class="column-info content">{{AEDSerialNumber}}</label>
          </div>
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title"> {{'iotModuleSoftwareRevisionNumber' | translate}} :</label>
            <label class="column-info content">{{iotModuleSoftwareRevisionNumber}}</label>
          </div>
        </div>

        <div class="d-flex ">
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title">{{'batterySerialNumber' | translate}} : </label>
            <label class="column-info content">{{batterySerialNumber}}</label>
          </div>
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title"> {{'iotModuleHardwareRevisionNumber' | translate}} :</label>
            <label class="column-info content">{{iotModuleHardwareRevisionNumber}}</label>
          </div>
        </div>

        <div class="d-flex ">
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title"> {{'hardwareRevisionNumber' | translate}} :</label>
            <label class="column-info content">{{hardwareRevisionNumber}}</label>
          </div>
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title"> {{'simOperatorName' | translate}} : </label>
            <label [ngClass]="'column-info content'">{{simOperatorName}}</label>
          </div>
        </div>

        <div class="d-flex">
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title" style="flex: 1;">{{'softwareRevisionNumber' | translate}} :</label>
            <label class="column-info content">{{softwareRevisionNumber}}</label>
          </div>
          <div class="flex-60" style="display: flex; justify-content: space-between; align-items: center;">
            <label class="column-info title" style="flex: 1;">{{'simTelNo' | translate}} :</label>
            <label class="column-info content">{{simTelNo}}</label>
          </div>
        </div>


        <div class="d-flex">
          <div class="flex-60 ">
            <div  class="d-flex ">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'AEDDeviceLCD' | translate}} :</label>
                <label class="column-info content">{{AEDDeviceLCD === 0 ?
                  ('lcdNonScreen' | translate) : 'lcdScreen' | translate}}</label>
              </div>
            </div>

            <div  class="d-flex ">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'primaryLanguagePack' | translate}} :</label>
                <label class="column-info content">{{primaryLanguagePack ? primaryLanguagePack.toLocaleUpperCase() : primaryLanguagePack}}</label>
              </div>
            </div>

            <div  class="d-flex ">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'secondaryLanguagePack' | translate}} :</label>
                <label class="column-info content">{{secondaryLanguagePack ? secondaryLanguagePack.toLocaleUpperCase() : secondaryLanguagePack}}</label>
              </div>
            </div>

            <div  class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'adultPadExpirationDate' | translate}} :</label>
                <label class="column-info content"><i style="margin-right: 1vmin" class="fa fa-calendar"></i>{{(adultPadExpirationDate? adultPadExpirationDate : '-') | wordForWordTranslate}}</label>
              </div>
            </div>

            <div  class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'pediatricPadExpirationDate' | translate}} :</label>
                <label class="column-info content"><i style="margin-right: 1vmin" class="fa fa-calendar"></i>{{(pediatricPadExpirationDate? pediatricPadExpirationDate : '-') | wordForWordTranslate}}</label>
              </div>
            </div>

            <div  class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'Guarantee Start Date' | translate}} :</label>
                <label class="column-info content"><i style="margin-right: 1vmin" class="fa fa-calendar"></i>{{(guaranteeStartDate? guaranteeStartDate : '-') | wordForWordTranslate}}</label>
              </div>
            </div>

            <div *ngIf="!isRegularUser" class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'Company Name' | translate}} :</label>
                <label class="column-info content">{{getCompanyName()}}</label>
              </div>
            </div>

            <div *ngIf="!isRegularUser" class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'Source' | translate}} :</label>
                <label class="column-info content">{{source}}</label>
              </div>
            </div>
          </div>

          <div class="flex-60">
            <label class="column-info title">{{ 'description' | translate }} :</label>
            <div class="relative-container">
              <textarea disabled='disabled' [(ngModel)]="description" [readOnly]="true" class="description-container" id="descriptionInput"></textarea>
            </div>
          </div>
        </div>

      </nb-tab>
      <nb-tab tabTitle="{{'Configuration Settings' | translate}}" [active]="activeTab === 'Configuration Settings'" [tabId]="'Configuration Settings'">

        <div class="d-flex ">
          <div class="flex-60">
            <label class="column-info header"><u>{{'General Settings' | translate}} : </u></label>
          </div>
          <div class="flex-60">
            <label class="column-info header"><u>{{'IOT Module Settings' | translate}} : </u></label>
          </div>
        </div>
        <div class="d-flex ">
          <div class="flex-60">
            <div  class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'adultPadExpirationDate' | translate}} :</label>
                <i
                  (click)="deleteAdultPadExpirationDate()"
                  *ngIf="adultTempQuery?.displayText || adultPadExpirationDate"
                  [nbTooltip]="'Delete Date' | translate"
                  style="cursor: pointer; color: #ae3434; margin-bottom: 1vmin; margin-right: 1vmin !important; transform: scale(0.9);" class="fa fa-trash">

                </i>
                <div class="column-info calendar-container" (click)="handlePadDateSelection('adult')" [title]="'Select dates' | translate">
                  <i style="margin-left: 1vmin; margin-right: 1.5vmin" class="fa fa-calendar"></i>
                  <label style="margin-bottom: 0; margin-right: 1vmin !important;"
                         class="column-info content"
                         [ngClass]="{
                            'placeholder-style': !adultTempQuery?.displayText && !adultPadExpirationDate
                          }"
                  >
                    {{(adultTempQuery?.displayText ? adultTempQuery.displayText : adultPadExpirationDate ? adultPadExpirationDate : calendarPlaceHolder) | translate}}
                  </label>
                </div>
              </div>
            </div>
            <div  class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'pediatricPadExpirationDate' | translate}} :</label>
                <i
                  (click)="deletePediatricPadExpirationDate()"
                  *ngIf="pediatricTempQuery?.displayText || pediatricPadExpirationDate"
                  [nbTooltip]="'Delete Date' | translate"
                  style="cursor: pointer; color: #ae3434; margin-bottom: 1vmin; margin-right: 1vmin !important; transform: scale(0.9);" class="fa fa-trash">

                </i>
                <div class="column-info calendar-container" (click)="handlePadDateSelection('pediatric')" [title]="'Select dates' | translate">
                  <i style="margin-left: 1vmin; margin-right: 1.5vmin" class="fa fa-calendar"></i>
                  <label style="margin-bottom: 0; margin-right: 1vmin !important;"
                         class="column-info content"
                         [ngClass]="{
                            'placeholder-style': !pediatricTempQuery?.displayText && !pediatricPadExpirationDate
                          }"
                  >
                    {{(pediatricTempQuery?.displayText ? pediatricTempQuery.displayText : pediatricPadExpirationDate ? pediatricPadExpirationDate : calendarPlaceHolder) | translate}}
                  </label>
                </div>
              </div>
            </div>
            <div  class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label *ngIf="!isRegularUser" class="column-info title"> {{'Guarantee Start Date' | translate}} :</label>
                <i
                  (click)="deleteGuaranteeDate()"
                  *ngIf="guaranteeTempQuery?.displayText || guaranteeStartDate"
                  [nbTooltip]="'Delete Date' | translate"
                  style="cursor: pointer; color: #ae3434; margin-bottom: 1vmin; margin-right: 1vmin !important; transform: scale(0.9);" class="fa fa-trash">

                </i>
                <div *ngIf="!isRegularUser" class="column-info calendar-container" (click)="handlePadDateSelection('guarantee')" [title]="'Select dates' | translate">
                  <i style="margin-left: 1vmin; margin-right: 1.5vmin" class="fa fa-calendar"></i>
                  <label style="margin-bottom: 0; margin-right: 1vmin !important;"
                         class="column-info content"
                         [ngClass]="{
                            'placeholder-style': !guaranteeTempQuery?.displayText && !guaranteeStartDate
                          }"
                  >
                    {{(guaranteeTempQuery?.displayText ? guaranteeTempQuery.displayText : guaranteeStartDate ? guaranteeStartDate : calendarPlaceHolder) | translate}}
                  </label>
                </div>
              </div>
            </div>
            <div *ngIf="!isRegularUser" class="d-flex" style="flex-wrap: nowrap;">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title"> {{'Company Name' | translate}} :</label>
                <nb-select class="custom-nb-select" [disabled]="!(userService.isDistributorUser() || userService.isRealmManager())" (selectedChange)="activateUpdateButton()" [(selected)]="companyName" size="tiny" selectWidth [options]="companyNameOptions" [placeholder]="'Select Company Name' | translate">
                  <nb-option *ngFor="let company of companyNameOptions" [value]="company">
                    {{ company }}
                  </nb-option>
                </nb-select>
              </div>
            </div>
          </div>
          <div class="flex-60">
            <div class="d-flex">
              <div class="flex-100" style="display: flex; justify-content: space-between; align-items: center;">
                <label class="column-info title">{{ 'Awaking' | translate }} :</label>
                <div>
                  <span [nbTooltip]="'Awaking Info Tooltip' | translate" class="info-icon-button">
                    <i style="color: white;" class="fas fa-info-circle"></i>
                  </span>
                  <nb-select
                    class="custom-nb-select"
                    [(selected)]="accelerometerStatusSelectValue"
                    size="tiny"
                    selectWidth
                    [placeholder]="'Awaking' | translate">
                    <nb-option [value]="'open'" [textContent]="'Open' | translate"></nb-option>
                    <nb-option [value]="'closed'" [textContent]="'Closed' | translate"></nb-option>
                  </nb-select>
                </div>
              </div>
            </div>
            <div class="d-flex">
              <div class="flex-100">
                <label class="column-info title">{{ 'description' | translate }} :</label>

                <div class="relative-container">
                  <textarea (ngModelChange)="activateUpdateButton()" class="description-container" [(ngModel)]="description" placeholder="{{ 'description placeholder' | translate }}"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="update-button-container">
          <button (click)="revertChanges()" [disabled]="cancelButtonStatus === 'passive'" [ngClass] ="'cancel-button-'+ cancelButtonStatus" [textContent]="'Cancel' | translate"></button>
          <button (click)="updateConfigurations()" [disabled]="updateButtonStatus === 'passive'" [ngClass] ="'update-button-'+ updateButtonStatus" [textContent]="'Update' | translate"></button>
        </div>
      </nb-tab>
      <nb-tab *ngIf="userService.isAselsanUser()" tabTitle="{{'APN Settings' | translate}}" [active]="activeTab === 'Apn Settings'" [tabId]="'Apn Settings'">
        <div class="d-flex ">
          <div class="flex-50">
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <label style="line-height: 25px" class="column-info title"> {{'simOperatorName' | translate}} : </label>
              <input disabled="disabled" [(ngModel)]="simOperatorName" style="text-align:left;" class="column-info disabled"/>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <label style="line-height: 25px" class="column-info title"> {{'simTelNo' | translate}} :</label>
              <input placeholder="{{'Enter Telephone No' | translate}}"
                     [(ngModel)]="simTelNo"
                     (ngModelChange)="activateApnUpdateButton()"
                     style="text-align:left;" class="column-info content"/>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <label style="line-height: 25px" class="column-info title"> {{'Apn Name' | translate}} :</label>
              <input [(ngModel)]="apnName" (ngModelChange)="activateApnUpdateButton()" style="text-align:left;" class="column-info content"/>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <label style="line-height: 25px" class="column-info title"> {{'Apn Username' | translate}} :</label>
              <input
                [(ngModel)]="apnUsername"
                (ngModelChange)="activateApnUpdateButton()"
                style="text-align:left;"
                class="column-info content"
                autocomplete="off"
              />
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center;">
              <label style="line-height: 25px" class="column-info title"> {{'Apn Password' | translate}} :</label>
              <div style="position: relative; display: inline-block;">
                <input [type]="showApnPassword ? 'text' : 'password'"
                       [(ngModel)]="apnPassword"
                       (ngModelChange)="activateApnUpdateButton()"
                       (focus)="onApnPasswordFocus()"
                       style="text-align:left;"
                       [ngClass]="{'error-border': displayErrors && this.errors.passwordError}"
                       [nbTooltip]="errors.passwordError | translate"
                       [nbTooltipStatus]="'danger'"
                       autocomplete="new-password"
                       [nbTooltipDisabled]="!errors.passwordError"
                       class="column-info content"/>
                <i *ngIf="apnPassword !== initialApnPassword"
                  class="fa"
                  [class.fa-eye]="!showApnPassword"
                  [class.fa-eye-slash]="showApnPassword"
                  (click)="togglePasswordVisibility()"
                   style="position: absolute; right: 25px; top: 40%; transform: translateY(-50%); cursor: pointer;"
                ></i>
              </div>
            </div>
            <div *ngIf="apnPassword !== initialApnPassword || apnPasswordTouched" style="display: flex; justify-content: space-between; align-items: center;">
              <label style="line-height: 25px" class="column-info title"> {{'Apn Password Verification' | translate}} :</label>
              <div style="position: relative; display: inline-block;">
                <input [type]="showApnPasswordVerification ? 'text' : 'password'" [(ngModel)]="apnPasswordVerification" style="text-align:left;"
                       [ngClass]="{'error-border': displayErrors && this.errors.passwordError}"
                       [nbTooltip]="errors.passwordError | translate"
                       [nbTooltipStatus]="'danger'"
                       [autocomplete]="false"
                       [nbTooltipDisabled]="!errors.passwordError"
                       autocomplete="new-password"
                       class="column-info content"/>
                <i *ngIf="apnPasswordVerification !== initialApnPasswordVerification"
                  class="fa"
                  [class.fa-eye]="!showApnPasswordVerification"
                  [class.fa-eye-slash]="showApnPasswordVerification"
                  (click)="togglePasswordVerificationVisibility()"
                  style="position: absolute; right: 25px; top: 35%; transform: translateY(-50%); cursor: pointer;"
                ></i>
              </div>
            </div>
          </div>
        </div>
        <div class="update-button-container">
          <button (click)="revertApnChanges()" [disabled]="cancelApnButtonStatus === 'passive'" [ngClass] ="'cancel-button-'+ cancelApnButtonStatus" [textContent]="'Cancel' | translate"></button>
          <button (click)="updateApnSettings()" [disabled]="updateApnButtonStatus === 'passive'" [ngClass] ="'update-button-'+ updateApnButtonStatus" [textContent]="'Update' | translate"></button>
        </div>
      </nb-tab>
      <nb-tab tabTitle="{{'bit' | translate}}" [active]="activeTab === 'bit'" [tabId]="'bit'">
        <table id="defibrillator-table">
          <thead>
          <tr class="header">
            <th>{{ 'testTime' | translate }}</th>
            <th>{{ 'testType' | translate }}</th>
            <th>{{ 'IOTModuleBatteryVoltageLevel' | translate }}</th>
            <th>{{ 'AEDDeviceBatteryVoltageLevel' | translate }}</th>
            <th>{{ 'testResult' | translate }}</th>
            <th></th> <!-- For the action column -->
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let defibrillatorTest of paginatedDefibrillatorTests">
            <td>{{ defibrillatorTest.testDay+'.'+defibrillatorTest.testMonth+ '.'+defibrillatorTest.testYear+','+defibrillatorTest.testHour+':'+defibrillatorTest.testMinute }}</td>
            <td>{{ defibrillatorTest.testType | translate }}</td>
            <td [ngClass]="defibrillatorTest.colorIOTModuleBatteryVoltageLevel">{{ defibrillatorTest.IOTModuleBatteryVoltageLevel }} V</td>
            <td [ngClass]="defibrillatorTest.colorAEDDeviceBatteryVoltageLevel">{{ defibrillatorTest.AEDDeviceBatteryVoltageLevel }} V</td>
            <td [ngClass]="defibrillatorTest.colorTestResult">{{ 'defibrillatorTestResult-' + calculateTestResultDescription(defibrillatorTest.testResult, defibrillatorTest.padTestResult) | translate }}</td>
            <td class="action-button"><i class="fa fa-eye" (click)="openTestDialog(defibrillatorTest)"></i></td>
          </tr>
          </tbody>
        </table>
      </nb-tab>
      <nb-tab *ngIf="isVisibleHealthCaseTab" tabTitle="{{'Case'|translate}}" [active]="activeTab === 'case'" [tabId]="'case'">
        <table id="healthcase-table">
          <thead>
          <tr [ngClass]="'header'">
            <th>{{'healthCaseId' | translate}}</th>
            <th>{{'caseDate' | translate}}</th>
            <th>{{'caseHour' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let healthCases of paginatedHealthCases; let i = index">
            <td>{{ healthCases.healthCaseId }}</td>
            <td>{{ healthCases.caseDate }}</td>
            <td>{{ healthCases.caseHour }}</td>
            <div class="action-button">
              <td><i class="fa fa-eye" (click)="openEkgDialog(healthCases, i)">  </i></td>
            </div>
          </tr>
          </tbody>
        </table>
      </nb-tab>
    </nb-tabset>
  </div>
  <div dialog-card-footer class="footer">
    <div class="footer-left">
      <img style="max-height: 2vmin; margin-right: 0.2vmin" class="column-info image" [src]="locationIcon" alt="Location source">
      <label style="line-height: 19px; margin-bottom: 0" class="column-info title">{{'coordinate' | translate}}: </label>
      <label style="line-height: 19px; margin-bottom: 0" class="column-info content">&nbsp;  {{defibrillatorLocation}} </label>
    </div>
    <div *ngIf="showSignalQuality" class="footer-right">
      <label style="line-height: 19px; margin-bottom: 0" class="column-info title">  {{this.connectionTypeName}} &nbsp; </label>
      <label style="line-height: 19px; margin-bottom: 0" class="column-info title">
        <img class="column-info image" src="{{this.signalQualityIcon}}">
      </label>
      <label style="line-height: 19px; margin-bottom: 0; margin-right: 4vmin" class="column-info title"> &nbsp;  {{this.signalQuality | translate}}</label>
      <label style="line-height: 19px; margin-bottom: 0" class="column-info title">{{'Last Update Time' | translate}}: </label>
      <label style="line-height: 19px; margin-bottom: 0" class="column-info content"> &nbsp;  {{this.lastUpdateTime}}</label>
    </div>
  </div>
</closeable-dialog>


